import { render, staticRenderFns } from "./appendices.vue?vue&type=template&id=e8ed1f86&scoped=true&"
import script from "./appendices.vue?vue&type=script&lang=js&"
export * from "./appendices.vue?vue&type=script&lang=js&"
import style0 from "./appendices.vue?vue&type=style&index=0&id=e8ed1f86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ed1f86",
  null
  
)

export default component.exports